import { ReactComponent as LinkIcon } from 'assets/icons/link16.svg'
import cx from 'classnames'
import { useLinkSelection } from 'common/Prose/Toolbar/hooks/useLinkSelection'
import { Button } from 'components/Button'
import { observer } from 'mobx-react-lite'
import { useMobileToolbar } from '../../../stores/MobileToolbarStore'
import { TopTiers } from '../../../Types'

import Styles from 'common/Prose/Toolbar/MobileToolbar/MobileToolbar.module.scss'

export const LinkMark = observer(() => {
  const mobileToolbarStore = useMobileToolbar()
  const { active, disabled } = useLinkSelection()

  const isLinkButtonSelected = mobileToolbarStore.topTier === TopTiers.Link

  const onClick = () => mobileToolbarStore.toggleTopTier(TopTiers.Link)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: active || isLinkButtonSelected,
        [Styles.disabled]: disabled,
      })}
      aria-label="Add link or mention"
      onClick={onClick}
    >
      <LinkIcon />
    </Button>
  )
})
